<!--
 * @Author: your name
 * @Date: 2021-09-07 08:45:21
 * @LastEditTime: 2021-09-27 16:33:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mofangguanwang\src\views\cooperation.vue
-->

<template>
  <div class="cooperation">
    <div class="banner">
      <img src="@/assets/cooperation/coopCoop.png">
    </div>
    <img class="cooperationPic" src="@/assets/cooperation/coopcustomer.png">
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/cooperation.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
}
</script>

<style>
</style>